import { useMemo } from "react";

import { useHistory } from "react-router-dom";
import { AssetTypeOpenAI, type DataConnectorOpenaiModel } from "@doitintl/cmp-models";
import { Button } from "@mui/material";

import { useCustomerContext } from "../../../Context/CustomerContext";
import NoAssets from "./components/NoAssets";
import OpenAIAssetsTabHeader from "./components/openai/OpenAIAssetsTabHeader";
import OpenAIAssetTable from "./components/openai/OpenAIAssetTable";

const OpenAIAssetsTab = ({ openaiConfigs }: { openaiConfigs: DataConnectorOpenaiModel[] }) => {
  const { customer } = useCustomerContext();
  const history = useHistory();

  const connectButton = useMemo(
    () => (
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          history.push(`/customers/${customer.id}/cloud-onboarding-openai`);
        }}
      >
        Connect new account
      </Button>
    ),
    [customer.id, history]
  );

  if (openaiConfigs && openaiConfigs.length === 0) {
    return <NoAssets assetType={AssetTypeOpenAI}>{connectButton}</NoAssets>;
  }

  return (
    <>
      <OpenAIAssetsTabHeader connectButton={connectButton} />
      <OpenAIAssetTable configs={openaiConfigs} />
    </>
  );
};

export default OpenAIAssetsTab;
